import { render, staticRenderFns } from "./TipsData.vue?vue&type=template&id=cc3d014a&scoped=true&"
import script from "./TipsData.vue?vue&type=script&lang=js&"
export * from "./TipsData.vue?vue&type=script&lang=js&"
import style0 from "./TipsData.vue?vue&type=style&index=0&id=cc3d014a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3d014a",
  null
  
)

export default component.exports